// extracted by mini-css-extract-plugin
module.exports = {"newsList":"NewsHonorList_newsList__1N5fu","front":"NewsHonorList_front__1eC9g","back":"NewsHonorList_back__2qK48"};